export interface ChartsOfAccount {
  id: number;
  name: string;
  glCodeId: string;
}
export interface RequestBody {
  id?: number;
  name?: string;
  email?: string;
  phoneNumber?: string;
  billingAddress?: string;
  mailingAddress?: string;
  paymentType?: string;
  paymentTerm?: string;
  vendorType?: VendorTypes;
  routingNumber?: string;
  taxNumber?: string;
  documentUrls?: string;
  notes?: string;
  chartsOfAccountsId?: number;
}

export interface IAllVendorsResponseType {
  response: {
    success: boolean;
    data: { vendors: [VendorDataResponse] } | [];
    message: string;
    error: string | null;
  };
  statusCode: number;
}

export interface IVendorByIdResponseType {
  response: {
    success: boolean;
    data: VendorDataResponse | null;
    message: string;
  };
  statusCode: number;
}

export interface ICreatedVendorResponseType {
  success: boolean;
  data: RequestBody;
  message: string;
}

export interface VendorDataResponse {
  id?: number;
  name?: string;
  email?: string;
  phoneNumber?: string;
  billingAddress?: string;
  mailingAddress?: string;
  paymentType?: PaymentTypeOption;
  paymentTerm?: string;
  vendorType?: VendorTypes;
  routingNumber?: string;
  taxNumber?: string;
  documentUrls: string;
  isVendorUsed?: boolean;
  notes?: string;
  restaurantId?: number;
  chartsOfAccounts: ChartsOfAccount | null;
}

export enum VendorTypes {
  ITEMIZED = 'Itemized',
  NON_ITEMIZED = 'NonItemized',
}

export enum PaymentTerms {
  CASH_ON_DELIVERY = 'Cash on Delivery',
  END_OF_MONTH = 'End of Month',
  NET_7 = 'Net 7',
  NET_10 = 'Net 10',
  NET_14 = 'Net 14',
  NET_15 = 'Net 15',
  NET_20 = 'Net 20',
  NET_25 = 'Net 25',
  NET_28 = 'Net 28',
  NET_30 = 'Net 30',
  NET_35 = 'Net 35',
  NET_45 = 'Net 45',
  NET_55 = 'Net 55',
  NET_60 = 'Net 60',
}

export enum VendorPaymentType {
  ACH = 'ACH',
  CREDIT_CARD = 'Credit Card',
}

export interface PaymentTypeOption {
  id: number;
  type: string;
  paymentType: string;
}
